import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import ProfilePageSkeleton from "../../profiles/ProfilePageSkeleton";
import CompanyHeaderSkeleton from "./company_header/company_header_skeleton";
import SideBarSkeleton from "./sidebar/sidebar_skeleton";
import CompanyPersonRowSkeleton from "./company_person_row_skeleton";

const PLACEHOLDER_ROWS = 6;

// Company's loading state, now composed on the shared <ProfilePageSkeleton> chassis so the
// skeleton mirrors the loaded section-card layout (header + a stacked "Our Experts" card +
// right rail). Engine-specific skeleton pieces (header, experts roster, sidebar) stay here.
// `railHasContent` mirrors the loaded page's rail-collapse decision (seeded from the server)
// so the skeleton and loaded page use the same column layout — no reflow when loading finishes.
function ShowPageSkeleton({ railHasContent = true }) {
  return (
    <ProfilePageSkeleton header={<CompanyHeaderSkeleton />} rightRail={railHasContent ? <SideBarSkeleton /> : null}>
      <div className="card p-4 mb-4 animated fadeIn faster">
        <div className="mb-3">
          <Skeleton height={18} width="15%" />
        </div>
        <ul className="list-unstyled mb-0">
          {Array.from({ length: PLACEHOLDER_ROWS }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className={`py-2${index < PLACEHOLDER_ROWS - 1 ? " border-bottom" : ""}`} key={`row-${index}`}>
              <CompanyPersonRowSkeleton />
            </li>
          ))}
        </ul>
      </div>
    </ProfilePageSkeleton>
  );
}

ShowPageSkeleton.propTypes = {
  railHasContent: PropTypes.bool,
};

export default ShowPageSkeleton;
